<template>
  <PForm
    v-model="validado"
    @cancel="limpiar"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :textCancel="$t('action.limpiar')"
  >
    <PRow>
      <PCol md="12">
        <PFormInputText v-model="valueLocal.ciudad" :label="$t('label.ciudad')"></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormInputText
          v-model="valueLocal.sucursal"
          :label="$t('label.sucursal')"
        ></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormDatepicker
          v-model="valueLocal.fechaNovedad"
          :label="$t('label.fechaNovedad')"
          :language="locale"
        ></PFormDatepicker>
      </PCol>
      <PCol md="12">
        <PFormDatepicker
          v-model="valueLocal.fechaSubida"
          :label="$t('label.fechaSubida')"
          :language="locale"
        ></PFormDatepicker>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormSelectMulti
          v-model="valueLocal.delegationsSelected"
          :options="delegations"
          optionValue="id"
          optionText="desDelegacion"
          :label="$t('label.delegaciones')"
          :placeholder="$t('option.select')"
          :readonly="this.clienteSelected?.id == undefined"
        />
      </PCol>
      <PCol md="12">
        <PFormSelectMulti
          v-model="valueLocal.puntosSelected"
          :options="puntos"
          optionValue="id"
          optionText="desPuntoservicio"
          :label="$t('label.puntoServicio')"
          :placeholder="$t('option.select')"
          :readonly="puntos.length === 0"
        />
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormInputText
          v-model="valueLocal.nombreRevisores"
          :label="$t('label.nombreRevisor')"
        ></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormInputText
          v-model="valueLocal.cedulasCiudadania"
          :label="$t('label.cedulasCiudadania')"
        ></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormInputText
          v-model="valueLocal.observaciones"
          :label="$t('label.observaciones')"
        ></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormInputText
          v-model="valueLocal.nombreArchivo"
          :label="$t('label.nombreArchivo')"
        ></PFormInputText>
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormSelectMulti
          v-model="valueLocal.estado"
          :options="optionEstados"
          optionValue="codParametro"
          optionText="desParametro"
          :label="$t('label.estado')"
          :placeholder="$t('option.select')"
        />
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormSelectMulti
          v-model="valueLocal.tipoNovedad"
          :options="optionTiposNovedad"
          optionValue="id"
          optionText="desParametro"
          :label="$t('label.tipoNovedad')"
          :placeholder="$t('option.select')"
        />
      </PCol>
    </PRow>
    <PRow>
      <PCol md="12">
        <PFormSelect
          v-model="valueLocal.aceptado"
          :options="optionsEstadoVideo"
          optionValue="id"
          optionText="desParametro"
          :label="$t('label.aceptado')"
          :placeholder="$t('option.select')"
        />
      </PCol>
    </PRow>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";
import { IVideoFilter } from "@/services";
import {
  ICliente,
  IClientexdel,
  IDelegacion,
  IParametro,
  IPuntoServicio,
  IUsuario,
} from "@/entities";

@Component({
  mixins: [VueMethods],
})
export class VideosFilterForm extends Vue {
  @Prop({ required: true }) value!: IVideoFilter;
  @Prop({ required: true }) optionEstados!: IParametro[];
  @Prop({ required: true }) optionTiposNovedad!: IParametro[];
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
    this.$set(
      this.valueLocal,
      "fechaNovedad",
      this.valueLocal.fechaNovedad
        ? new Date(this.valueLocal.fechaNovedad)
        : this.getStartDate(new Date().toISOString())
    );
    this.$set(
      this.valueLocal,
      "fechaSubida",
      this.valueLocal.fechaSubida ? new Date(this.valueLocal.fechaSubida) : undefined
    );
  }
  validado = false;
  valueLocal: IVideoFilter = {
    ciudad: undefined,
    sucursal: undefined,
    fechaNovedad: this.getStartDate(new Date().toISOString()),
    fechaSubida: undefined,
    nombreRevisores: undefined,
    cedulasCiudadania: undefined,
    observaciones: undefined,
    nombreArchivo: undefined,
    aceptado: null,
    estado: [],
    tipoNovedad: [],
    delegationsSelected: [],
    puntosSelected: [],
  };
  initialValueLocal: IVideoFilter = {
    ciudad: undefined,
    sucursal: undefined,
    fechaNovedad: this.getStartDate(new Date().toISOString()),
    fechaSubida: undefined,
    nombreRevisores: undefined,
    cedulasCiudadania: undefined,
    observaciones: undefined,
    nombreArchivo: undefined,
    aceptado: null,
    estado: [],
    tipoNovedad: [],
    delegationsSelected: [],
    puntosSelected: [],
  };
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getLocale") locale!: Locale;
  @Getter("getLoggedUser") getLoggedUser!: IUsuario;
  @Getter("getClienteSelected") clienteSelected: ICliente | undefined;
  public delegations: IDelegacion[] = [];
  public puntos: IPuntoServicio[] = [];

  mounted(): void {
    this.getDelegaciones();
    this.getPuntos();
  }

  private cliente: ICliente | undefined = undefined;
  private static readonly SORTBY_DELEGATIONS: string = "desDelegacion";
  private static readonly SORTBY_PUNTOS: string = "desPuntoservicio";

  async getDelegaciones(): Promise<void> {
    this.cliente = this.clienteSelected;
    this.cliente?.clientexdels.forEach((clientexdel) => {
      if (clientexdel.active) this.delegations.push(clientexdel.delegacion);
    });
    this.delegations.sort((a, b) => this.sortAscending(a, b, VideosFilterForm.SORTBY_DELEGATIONS));
  }
  async getPuntos(): Promise<void> {
    if (this.cliente != undefined) {
      let cxds = this.cliente.clientexdels;
      if (this.getLoggedUser.nivel == 4) {
        const puntosPermitidos = this.getLoggedUser.permisos.map((punto) => punto.puntoservicio.id);
        cxds.forEach((clientexdel) => {
          clientexdel.puntosservicio = clientexdel.puntosservicio.filter((punto) =>
            puntosPermitidos.includes(punto.id)
          );
        });
      }
      if (this.valueLocal.delegationsSelected?.length) {
        cxds = cxds?.filter((cxd: IClientexdel) =>
          this.valueLocal.delegationsSelected.includes(cxd.delegacion?.id)
        );
      }
      cxds?.forEach((cxd) =>
        this.puntos.push(
          ...(cxd.puntosservicio.sort((a, b) =>
            this.sortAscending(a, b, VideosFilterForm.SORTBY_PUNTOS)
          ) || [])
        )
      );
    }
  }

  limpiar(): void {
    this.valueLocal.ciudad = undefined;
    this.valueLocal.sucursal = undefined;
    this.valueLocal.nombreRevisores = undefined;
    this.valueLocal.cedulasCiudadania = undefined;
    this.valueLocal.observaciones = undefined;
    this.valueLocal.nombreArchivo = undefined;
    this.valueLocal.aceptado = null;
    this.valueLocal.estado = [];
    this.valueLocal.tipoNovedad = [];
    this.valueLocal.delegationsSelected = [];
    this.valueLocal.puntosSelected = [];
    this.$set(this.valueLocal, "fechaNovedad", this.getStartDate(new Date().toISOString()));
    this.$set(this.valueLocal, "fechaSubida", undefined);
    if (!this.isInitialObject(this.value, this.initialValueLocal)) {
      this.$emit("input", this.valueLocal);
      this.$emit("cancel", { action: "clean" });
    }
  }
  action(action: string): void {
    this.$emit("input", this.valueLocal);
    this.$emit("action", { data: this.valueLocal, action: action });
  }

  get optionsEstadoVideo() {
    return [
      {
        id: true,
        desParametro: this.$t("label.si"),
      },
      {
        id: false,
        desParametro: this.$t("label.no"),
      },
    ];
  }
}
export default VideosFilterForm;
</script>
